import { Component, Input } from '@angular/core';
import { SignatureService } from '../services/signature.service';
import { LoaderService } from '../services/loader.service';

@Component({
    selector: 'fs-purchase-orders-sign-iframe',
    templateUrl: './purchase-orders-sign-iframe.component.html',
    styleUrls: ['./purchase-orders-sign-iframe.sass']
})

export class PurchaseOrdersSignIframeComponent {

    @Input() isErrorReport: boolean = false;

    constructor(private loaderService: LoaderService,
        public signatureService: SignatureService) {
    }

    onLoadIframe() {
        this.loaderService.decreaseLoaderCount();
    }
}
